import React, { FC, useEffect, useState } from 'react';
import styles from './header.module.scss';
import { Link } from 'react-router-dom';
import logo from '../../../../assets/images/logo.svg'
import HeaderNavContent from '../components/header-nav-content/header-nav-content';
import HeaderUser from '../components/header-user/header-user';

interface HeaderProps {}

const Header: FC<HeaderProps> = () => {
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 10) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
  }, []);

  return (
    // <!-- Main Header-->
    <header
      className={`main-header  ${
        navbar ? "fixed-header animated slideInDown" : ""
      }`}
    >
      {/* <!-- Main box --> */}
      <div className="main-box">
        {/* <!--Nav Outer --> */}
        <div className="nav-outer">
          <div className="logo-box">
            <div className="logo">
              <Link to="/">
                <img src={logo} alt="brand" />
              </Link>
            </div>
          </div>
          {/* End .logo-box */}

          <HeaderNavContent />
          {/* <!-- Main Menu End--> */}
        </div>
        {/* End .nav-outer */}

      <HeaderUser />
      </div>
    </header>
  );
}
export default Header;
